<template>
  <b-card class="mb-3">

    <b-card-title>Purple Phone Contacts</b-card-title>

    <section v-if="loading">
      <b-spinner class="d-block" variant="primary"></b-spinner>
    </section>

    <section v-else>
      <div class="contacts-table" v-if="contacts && contacts.length > 0">
        <b-table
          hover cy="contacts-table"
          :fields="columns"
          :items="contacts"
          :current-page="currentPage"
          :per-page="perPage"
          :responsive="true"
        >
          <template #cell(actions)="data">
            <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button v-if="data.item.purple_phone_status !== 'Approved'" class="full-nested-btn"
                                      @click="showModal('modal-approve', true, data.item)">
                Approve
              </b-dropdown-item-button>
              <b-dropdown-item-button v-if="data.item.purple_phone_status !== 'Rejected'" class="full-nested-btn"
                                      @click="showModal('modal-reject', true, data.item)">
                Reject
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
      </div>
      <b-row v-if="contacts && contacts.length > 0">
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <div v-else>
        <p>Visitor has no purple phone contacts.</p>
      </div>
    </section>

    <b-modal id="modal-approve" hide-footer>
      <approve-purple-phone-contact
        v-if="activeContact"
        :contact="activeContact"
        @approved="updateContact"
        @close="closeModals()"
      />
    </b-modal>

    <b-modal id="modal-reject" hide-footer>
      <reject-purple-phone-contact
        v-if="activeContact"
        :contact="activeContact"
        @rejected="updateContact"
        @close="closeModals()"
      />
    </b-modal>
  </b-card>
</template>

<style></style>

<script>
  import VisitorService from '@/services/VisitorService';
  import {logger} from '@/util/logger';
  import ApprovePurplePhoneContact from '@/components/contacts/ApprovePurplePhoneContact';
  import RejectPurplePhoneContact from '@/components/contacts/RejectPurplePhoneContact';

  export default {
    name: 'visitors-contacts',
    components: {
      ApprovePurplePhoneContact,
      RejectPurplePhoneContact,
    },
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
    },
    watch: {
      visitor_user_id() {
        this.getContacts(); // Get new visitor info
      },
    },
    data() {
      return {
        loading: true,
        contacts: [],
        columns: [
          {
            key: 'prisoner_number',
            label: this.$options.filters.term('prison', true) + ' Number',
          },
          {
            key: 'fullName',
            label: 'Name',
          },
          {
            key: 'relationship',
            label: 'Relationship',
          },
          {
            key: 'purple_phone_status',
            label: 'Status',
          },
          {
            key: 'purple_phone_rejection_reason',
            label: 'Reason',
          },
          {
            key: 'actions',
            label: 'Actions',
          }
        ],
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
        activeContact: null,
      };
    },
    mounted() {
      this.getContacts();
    },
    methods: {
      getContacts() {
        this.loading = true;

        VisitorService.getVisitorContacts(this.visitor_user_id).then(res => {
          if(res.data && res.data.contacts && res.data.contacts.length) {
            this.contacts = res.data.contacts.filter((contact) => {
              return !!contact.purple_phone_status
            }).map((contact) => {
              return {
                fullName: `${contact.prisoner.firstname} ${contact.prisoner.lastname}`,
                ...contact
              };
            });
          }
          this.totalRows = this.contacts.length;
          this.loading = false;
        }).catch(err => {
          logger.error('Error getting visitors contacts', err, {visitorUserId: this.visitorUserId}, 'VisitorsContacts:getContacts');
          this.$toast.error('Error getting users contacts. Please check your connection and refresh the page', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      showModal(name, value, contact) {
        this.activeContact = contact
        if (value) {
          this.$bvModal.show(name);
        } else {
          this.$bvModal.hide(name);
        }
      },
      updateContact(updatedContact) {
        this.contacts.map((contact) => {
          if(contact._id === updatedContact._id) {
            contact.purple_phone_status = updatedContact.purple_phone_status
            contact.purple_phone_rejection_reason = updatedContact.purple_phone_rejection_reason
          }
        });
      },
      closeModals() {
        this.$bvModal.hide('modal-approve');
        this.$bvModal.hide('modal-reject');
      }
    }
  };
</script>
